import { Footer } from 'components/Footer'
import { Header, HeaderType } from 'components/Header'
import { NextPage } from 'next'
import { NextSeo } from 'next-seo'
import Error from 'next/error'
import { useRouter } from 'next/router'
import { useIntl } from 'react-intl'
import { findRole } from 'utils/role'
import { ExploreRole } from 'views/explore-role'

const ExploreRolePage: NextPage = () => {
  const { query } = useRouter()
  const { formatMessage } = useIntl()
  const role = findRole(query.roleSlug)

  if (!role) {
    return <Error statusCode={404} />
  }

  return (
    <>
      <NextSeo
        title={formatMessage({ id: 'explore.role.meta.title' }, { role: formatMessage({ id: role.uuid }) })}
        description={formatMessage({ id: 'explore.role.meta.description' }, { role: formatMessage({ id: role.uuid }) })}
      />
      <Header role={role} type={HeaderType.Search} />
      <ExploreRole role={role} />
      <Footer />
    </>
  )
}

export default ExploreRolePage
